import { render, staticRenderFns } from "./orderingCodes.vue?vue&type=template&id=1774133e&scoped=true"
import script from "./orderingCodes.vue?vue&type=script&lang=js"
export * from "./orderingCodes.vue?vue&type=script&lang=js"
import style0 from "./orderingCodes.vue?vue&type=style&index=0&id=1774133e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1774133e",
  null
  
)

export default component.exports